import { apiCall } from './BaseAction';
import {
  DeleteCasePhoto,
  GetCaseTypes,
  ReportCase,
  TDeleteCasePhotoAction,
  TGetCaseTypesAction,
  TReportCaseAction,
  TUploadCasePhotoAction,
  UploadCasePhoto,
} from '../types/Cases';
import { TSurveyRespondentId } from '../types/Survey';
import { TClearCasePhotosAction, ClearCasePhotos } from '../types/Cases';
import { Dispatch } from 'redux';

export const getCaseTypes = (lang?: string) => {
  return apiCall<TGetCaseTypesAction>(
    GetCaseTypes,
    'GET',
    '/cases/types',
    true,
    null,
    { lang }
  );
};

export type TPhotoUploadRequestData = {
  filename: string;
  content: string;
};
export const uploadPhoto = (
  filename: string,
  content: string,
  additionalData?: Record<string, string | boolean | number>
) => {
  return apiCall<TUploadCasePhotoAction, TPhotoUploadRequestData>(
    UploadCasePhoto,
    'POST',
    '/cases/photo',
    true,
    { filename, content, ...additionalData }
  );
};

export const deletePhoto = (photoId: number) => {
  return apiCall<TDeleteCasePhotoAction>(
    DeleteCasePhoto,
    'DELETE',
    `/cases/photo/${photoId}`,
    true
  );
};

export type TReportCaseRequest = {
  category: number;
  problemDescription: string;
  authorName: string;
  photos: Array<number>;
  nearMissInjuredName: string;
  nearMissDate: string;
  respondentId?: TSurveyRespondentId;
  location: number;
  department: number;
  questionId?: number;
  violenceInjuredName: string;
  violenceDate: string;
  violencePhysicalReaction: number;
  violencePsychologicalReaction: number;
  violenceWitness: string;
  violenceCauserOfDamage: string;
  violenceCauserStatus: number;
  violencePhysicalViolence: number;
  violencePsychologicalViolence: number;
  violenceTrigger: number;
  violenceDuration: number;
  accidentInjuredName: string;
  accidentDate: string;
  accidentIncapacityForWork: number | null;
};

export type TReportCreateResponse = {
  caseId: number;
  code: string | null;
}

const REPORT_CASE_TIMEOUT_MS = 90000;

export const reportCase = (data: TReportCaseRequest) => {
  return apiCall<TReportCaseAction, TReportCaseRequest, TReportCreateResponse>(
    ReportCase,
    'POST',
    '/cases',
    true,
    { ...data },
    {},
    false,
    REPORT_CASE_TIMEOUT_MS
  );
};

export const clearPhotos = () => {
  return (dispatch: Dispatch<TClearCasePhotosAction>) => {
    dispatch({
      type: ClearCasePhotos.SUBMIT,
    });
  };
};
